import React from 'react';
import { useApolloClient } from '@apollo/client';
import { Flex, TextV2 } from '@withjoy/joykit';
import { JoyAiV2 } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';
import { useEventInfo } from '@shared/utils/eventInfo';
import { AiBorderBox } from '@shared/components/AiBorderBox';
import { useAutoPopulation } from '@shared/utils/accommodations';
import { AccommodationHotelsDocument, PageContainerBySlugDocument } from '@graphql/generated';
import { ShimmerAnimation } from '@shared/components/ShimmerAnimation';

export const AsyncAutoPopulationStatus = React.memo(() => {
  const { tq } = useTranslation('autoPopulation');

  const client = useApolloClient();
  const { eventHandle } = useEventInfo();

  const { status } = useAutoPopulation({
    mode: 'poll-only',
    context: 'AsyncAutoPopulationStatus',
    // On completion, refetch accommodations data to update the UI (this is only called once).
    onComplete: () => {
      if (eventHandle) {
        client.refetchQueries({
          include: [PageContainerBySlugDocument, AccommodationHotelsDocument],
        });
      }
    },
  });

  if (status !== 'PENDING') return null;

  return (
    <Flex
      alignItems="center"
      marginX={6}
      marginBottom={6}
      role="status"
      aria-live="polite"
    >
      <AiBorderBox
        padding={6}
        background="white"
        borderRadius={12}
      >
        <ShimmerAnimation enabled={true}>
          <Flex gap={3}>
            <JoyAiV2 size={48} />
            <TextV2
              typographyVariant={'hed1'}
              textAlign="left"
            >
              {tq`Finding hotels near your venue with exclusive event rates, up to 40% off.`}
            </TextV2>
          </Flex>
        </ShimmerAnimation>
      </AiBorderBox>
    </Flex>
  );
});
